import { createFeatureSelector, createSelector } from '@ngrx/store';
import { accountDetailFeatureKey, State } from './account-detail.reducer';

export const accountDetailFeature = createFeatureSelector<State>(accountDetailFeatureKey);

export const getAccount = createSelector(accountDetailFeature, (state) => {
   return state.account;
});

export const getAccountCallState = createSelector(accountDetailFeature, (state) => {
   return state.callState;
});

export const getAccountId = createSelector(accountDetailFeature, (state) => {
   return state.account?.accountId;
});

export const getPresenceCredentialUsername = createSelector(accountDetailFeature, (state) => {
   return state.account?.presenceUser;
});
